module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-contact-us"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('BlockTitle', {
    attrs: {
      "props": _vm.props.acf.block_title
    }
  }), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "padding-left": "1rem",
      "padding-right": "1rem"
    }
  }, [_vm._v("Note: Each location has designated hours & days open for in-person patient care that vary weekly.")]), _c('FormContact', {
    attrs: {
      "props": _vm.props.acf
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e7b110f","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/contact-us/contact-us.pug
// module id = 571
// module chunks = 1